export default __webpack_public_path__ + "static/media/1.84eb34b7.jpg";